import React from 'react';
import { Button } from 'antd';

interface FilterResetLinkProps {
  onClick: () => void;
}

const FilterResetLink: React.FC<FilterResetLinkProps> = ({ onClick }) => (
  <Button
    type="link"
    onClick={onClick}
    style={{ padding: 0, height: 'auto', textDecoration: 'underline' }}
  >
    Reset
  </Button>
);

export default FilterResetLink;